import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronLeftExtraSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13.25 17a1 1 0 0 1-.78-.37l-3.25-4a1 1 0 0 1 0-1.26l3.25-4a.999.999 0 0 1 1.753.913 1 1 0 0 1-.203.347L11.28 12l2.74 3.37a1 1 0 0 1-.77 1.63"
    />
  </svg>
);
export default SvgChevronLeftExtraSmall;
